import { atom } from "recoil"

export const AtomCurrentBgName = atom({
    key:'ATOMCURBG',
    default:''
})
  